import React from 'react';
import { includes } from 'lodash';
import InsightsTableRow from '../_shared/InsightsTableRow';

const OverdueAssignmentsRow = ({ number, rowData }) => {
  const showLessonIcon = includes('User Groups', rowData.type);
  const icon = showLessonIcon ? 'lesson' : 'user';

  return (
    <InsightsTableRow
      number={number}
      item={rowData.title}
      amount={rowData.overdue_count}
      href={rowData.urls.overview}
      icon={icon}
      amountHREF={rowData.urls.overdue}
    />
  );
};

export default OverdueAssignmentsRow;
